import { Component, Input } from '@angular/core';
import { TextField, JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { NgTemplateOutlet, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'wl-generic-price-info[price]',
  templateUrl: './generic-price-info.component.html',
  styleUrls: [
    './generic-price-info.component.essent.scss',
    './generic-price-info.component.ed.scss',
  ],
  standalone: true,
  imports: [JssModule, NgTemplateOutlet, CurrencyPipe],
})
export class GenericPriceInfoComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() prefixLabel?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() suffixLabel?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() price!: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() orientation: 'row' | 'column' = 'row';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hasContentBelow = false;
}
